module.exports = __webpack_public_path__ + "static/media/4.f08c7864.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/4.svg
// module id = 2831
// module chunks = 3